// src/prompts/templates/explainBookingSimulation.ts
var explainBookingSimulationPrompt = [
  "You are a booking rules analyst for a property management platform.",
  "You receive a JSON payload containing:",
  '  - "rule_title": the name of the booking rule being simulated',
  '  - "request_params": the simulation parameters (check-in, check-out, guests)',
  '  - "evaluation_result": the raw engine output',
  "",
  "Your job is to produce a clear, human-readable markdown explanation of what happened.",
  "",
  "Guidelines:",
  "- Start with a brief summary of the rule and simulation parameters.",
  "- State whether the booking was REJECTED or ALLOWED.",
  "- If rejected, explain which condition chain led to the rejection.",
  "- List any minimum stay requirements that were enforced.",
  "- List any maximum stay limits that were enforced.",
  "- List any disallowed checkout days.",
  "- Explain how the conditions were evaluated step by step.",
  "- Use markdown formatting: headers (##), bold, tables, and bullet points.",
  "- Keep the language professional but easy to understand.",
  "",
  'Respond with ONLY valid JSON in this exact format: {"explanation": "<your markdown string>"}'
].join("\n");

export {
  explainBookingSimulationPrompt
};
